export enum AccountRequirement {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
  NO_ACCOUNT = 'NO_ACCOUNT',
}

export namespace AccountRequirement {
  export function getAll(): AccountRequirement[] {
    return [
      AccountRequirement.REQUIRED,
      AccountRequirement.OPTIONAL,
      AccountRequirement.NO_ACCOUNT,
    ];
  }

  export function getDisplayName(type?: AccountRequirement): string {
    switch (type) {
      case AccountRequirement.REQUIRED:
        return 'APP.ACCOUNT_REQUIREMENT.REQUIRED';
      case AccountRequirement.OPTIONAL:
        return 'APP.ACCOUNT_REQUIREMENT.OPTIONAL';
      case AccountRequirement.NO_ACCOUNT:
        return 'APP.ACCOUNT_REQUIREMENT.NO_ACCOUNT';
      default:
        return '';
    }
  }
}
